import {Dialog} from 'primereact/dialog'
import {InputMask} from 'primereact/inputmask'
import {InputText} from 'primereact/inputtext'
import {InputTextarea} from 'primereact/inputtextarea'
import {forwardRef, useCallback, useImperativeHandle, useState} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'

const ObservationComment = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const [commentData, setCommentData] = useState('')
    const [visible, setVisible] = useState(false)
    const {translateKeys} = TranslateUtils()
    const handleShowForm = useCallback(data => {
        setCommentData({
            fullName: data?.fullName ?? '',
            comment: data?.comment ?? '',
            dateTime: data?.dateTime ?? '',
            initials: data?.initials ?? '',
        })
        setVisible(true)
        blockOverflownScroll()
    }, [])

    const handleHideForm = useCallback(() => {
        setCommentData({})
        setVisible(false)
        unblockOverflownScroll()
    }, [])

    return (
        <Dialog
            header={<strong>{translateKeys('Comment')}</strong>}
            visible={visible}
            closeOnEscape={true}
            onHide={() => handleHideForm(false)}
            style={{width: '50vw'}}
            breakpoints={{'960px': '75vw', '641px': '100vw'}}>
            <div className="flex gap-1 ">
                <div className="col-4 m-0 p-0">
                    <h5 className="mb-1">{translateKeys('Patient Name')}</h5>
                    <InputText
                        className="w-full"
                        value={commentData?.fullName ?? ''}
                        onChange={() => {}}
                    />
                </div>
                <div className="col-4 m-0 p-0">
                    <h5 className="mb-1">{translateKeys('Initials')}</h5>
                    <InputText
                        className="w-full"
                        value={commentData?.initials ?? ''}
                        onChange={() => {}}
                    />
                </div>
                <div className="col-4 m-0 p-0">
                    <h5 className="mb-1">{translateKeys('Date Time')}</h5>
                    <InputMask
                        className="w-full"
                        mask="99-99-9999 99:99"
                        value={commentData?.dateTime}
                        onChange={() => {}}
                    />
                </div>
            </div>
            <div className="col-12 m-0 p-0 mt-2">
                <h5 className="mb-1">{translateKeys('Comment')}</h5>
                <InputTextarea
                    className="w-full"
                    value={commentData?.comment}
                    autoResize
                    onChange={() => {}}
                />
            </div>
        </Dialog>
    )
})

export default ObservationComment
